import { BackendError } from './base';
import General from './general';

type ClickSignErrorResponse = {
    payload: {
        errors: string[];
    };
};

class CouldNotLinkContract extends BackendError {}
class ContractNotAvailable extends BackendError {}
class CannotCloseContract extends BackendError {}
class ContractDoesNotExist extends General.NotFound {}
class ContractRefunded extends General.NotFound {}
class ClickSignService extends BackendError {
    get clickSignMessage(): string {
        return (this.response as ClickSignErrorResponse)?.payload?.errors?.join(
            ', '
        );
    }
}
class SignerPartyAlreadyExists extends BackendError {}

class ExternalContractExpired extends BackendError {}
class ExternalContractAlreadySigned extends BackendError {}
class ExternalContractDocumentsDownloadExpired extends BackendError {}

class CannotCloseContractWithDeceasedValidation extends BackendError {}

export default {
    CouldNotLinkContract,
    ContractDoesNotExist,
    ClickSignService,
    ContractNotAvailable,
    CannotCloseContract,
    ContractRefunded,
    SignerPartyAlreadyExists,
    ExternalContractExpired,
    ExternalContractAlreadySigned,
    ExternalContractDocumentsDownloadExpired,
    CannotCloseContractWithDeceasedValidation,
};
export type { ClickSignService };
